<template>
  <base-modal
      icon="link"
      title="Set URL">
    <base-input
        ref="url-input"
        v-model="localUrl"
        type="text"
        placeholder="https://..."
        @keypress.enter="onSetUrl(localUrl)"/>
    <template #footer>
      <base-button
          v-if="url"
          text="Remove"
          @click="onSetUrl(null)"/>
      <base-button
          text="Set"
          @click="onSetUrl(localUrl)"/>
    </template>
  </base-modal>
</template>

<script>
import BaseButton from '@/components/core/BaseButton.vue';
import BaseInput from '@/components/core/BaseInput.vue';
import BaseModal from '@/components/core/modal/BaseModal.vue';

export default {
  name: 'MessageModal',
  components: {
    BaseModal,
    BaseInput,
    BaseButton,
  },
  props: {
    url: String,
    onSetUrl: Function,
  },
  data() {
    return {
      localUrl: this.url,
    };
  },
  mounted() {
    this.$refs['url-input'].$el.focus();
  },
};
</script>

<style lang="scss" scoped>
input {
  width: 20rem;
}
</style>
